import ScalarSearchInput_default from "./ScalarSearchInput.vue.js";
export { ScalarSearchInput_default as ScalarSearchInput };
